<script setup lang="ts" generic="T extends object = Record<string, unknown>">
  import type { HTMLAttributes } from 'vue';
  import type { TreeRootEmits, TreeRootProps } from 'reka-ui';
  import { reactiveOmit } from '@vueuse/core';
  import { TreeRoot, useForwardPropsEmits } from 'reka-ui';
  import { cn } from '@/shared/lib/utils';

  const props = withDefaults(
    defineProps<TreeRootProps<T> & { indent?: number; class?: HTMLAttributes['class'] }>(),
    {
      indent: 20,
    }
  );

  const emits = defineEmits<TreeRootEmits<T>>();

  const delegatedProps = reactiveOmit(props, 'indent', 'class');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <TreeRoot
    data-slot="tree"
    v-bind="forwarded"
    :class="cn('flex flex-col outline-none', props.class)"
  >
    <template #default="slotProps">
      <slot v-bind="{ ...slotProps, indent: props.indent }" />
    </template>
  </TreeRoot>
</template>
